import React from "react";

import { FormattedMessage } from "react-intl";
import { Link } from "react-router-dom";

import { authCommonStyles as commonStyles } from "@mapmycustomers/auth";
import { Button } from "@mapmycustomers/ui";

import Path from "@app/enum/Path";

import styles from "./SuccessScreenCommon.module.scss";

const ResetPasswordSuccessScreen = () => {
  return (
    <div className={commonStyles.container}>
      <p className={commonStyles.title}>
        <FormattedMessage
          id="auth.resetPassword.form.success.title"
          defaultMessage="Your new password has been set"
          description="Title on the successfully password reset"
        />
      </p>
      <p className={commonStyles.description}>
        <FormattedMessage
          id="auth.resetPassword.form.success.description"
          defaultMessage="Please login again using your new password"
          description="Description on the successfully password reset"
        />
      </p>
      <Link className={styles.returnLink} to={Path.LOGIN}>
        <Button className={styles.returnButton} type="primary">
          <FormattedMessage
            id="auth.resetPassword.form.login.link"
            defaultMessage="Login"
            description="Title of the Login Link"
          />
        </Button>
      </Link>
    </div>
  );
};

export default ResetPasswordSuccessScreen;
